import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'

export default [
  {
    path: routeNames.materialManagePostList,
    component: () => import('../../pages/materialManage/postList'),
    meta: { title: '帖子素材管理' }
  },
  {
    path: routeNames.materialManagePostAdd,
    component: () => import('../../pages/materialManage/postAdd'),
    meta: { title: '新建帖子素材', hideInMenu: true }
  },
  {
    path: routeNames.materialManageCommentList,
    component: () => import('../../pages/materialManage/commentList'),
    meta: { title: '评论素材管理' }
  },
  {
    path: routeNames.materialManageMedalList,
    component: () => import('../../pages/materialManage/medalList'),
    meta: { title: '勋章认证管理' }
  },
  {
    path: routeNames.materialManageMedalAdd,
    component: () => import('../../pages/materialManage/medalAdd'),
    meta: { title: '新建勋章认证管理', hideInMenu: true }
  }
] as TRoutes[]
